import type { SubtitleStyleOptions } from '../language-menu/language-menu.types';

import classNames from 'classnames';
import { type CSSProperties, useMemo } from 'react';

import { sanitizeSubtitles } from '../../utils/html';

import styles from './subtitles.module.css';

type Props = {
  content: string;
  withSpaceForBottomBar?: boolean;
  wrapperWidth?: number;
  subtitleStyleOptions?: SubtitleStyleOptions;
};

export function Subtitles({ withSpaceForBottomBar, content, wrapperWidth = 0, subtitleStyleOptions }: Props) {
  const [fontFamily, fontVariant] = subtitleStyleOptions?.fontFamily?.split('|') || [];

  const sanitizedHtmlContent = useMemo(() => sanitizeSubtitles(content), [content]);

  return (
    <div
      data-testid="subtitle"
      className={classNames(styles.subtitles, { [styles.withSpaceForBottomBar]: withSpaceForBottomBar })}
      style={
        {
          '--subtitleFontColor': subtitleStyleOptions?.fontColor,
          '--subtitleBackgroundColor': subtitleStyleOptions?.backgroundColor,
          '--subtitleBackgroundTransparency': subtitleStyleOptions?.backgroundTransparency,
          '--subtitleFontSize': subtitleStyleOptions?.fontSize,
          '--subtitleFontFamily': fontFamily,
          '--subtitleFontVariant': fontVariant || 'normal',
          '--wrapperWidth': wrapperWidth,
        } as CSSProperties
      }
      dangerouslySetInnerHTML={{ __html: sanitizedHtmlContent }}
    ></div>
  );
}
